import { type FieldValues, useController } from 'react-hook-form';
import type {
  FormControlProps,
  TypedUseControllerProps,
} from '../FormControl/FormControl.types';
import { TextAreaField } from '../TextAreaField/TextAreaField';
import type { TextAreaFieldProps } from '../TextAreaField/TextAreaField.types';

export type FormTextAreaProps<TFieldValues extends FieldValues = FieldValues> =
  TypedUseControllerProps<TFieldValues, string> &
    FormControlProps<TextAreaFieldProps>;

export const FormTextArea = <TFieldValues extends FieldValues = FieldValues>({
  disabled,
  ...props
}: FormTextAreaProps<TFieldValues>) => {
  const {
    field: { ref, ...field },
    formState: { errors },
  } = useController(props);

  const error = errors[props.name]?.message?.toString();

  return (
    <TextAreaField
      {...props}
      {...field}
      disabled={disabled}
      error={error}
      inputRef={ref}
    />
  );
};
